import { render, staticRenderFns } from "./tablePreview.vue?vue&type=template&id=c8bff4de&scoped=true&"
import script from "./tablePreview.vue?vue&type=script&lang=js&"
export * from "./tablePreview.vue?vue&type=script&lang=js&"
import style0 from "./tablePreview.vue?vue&type=style&index=0&id=c8bff4de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8bff4de",
  null
  
)

export default component.exports